export default class ProductTable {
    constructor() {
        this.init()
        this.isInit = false
    }

    init() {
        const targetNode = document.querySelector(".tx-ffndfproductcatalogue-pi2")
        if (targetNode) {
            const observer = new MutationObserver((mutationsList, observer) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === "childList") {
                        this.table = document.querySelector("[data-product-table]")
                        this.tableHeader = document.querySelector("[data-table-header-container] .header")

                        if (this.table) {
                            observer.disconnect();
                            this.watchTable()
                        }
                    }
                }
            });

            const config = {childList: true, subtree: true};
            observer.observe(targetNode, config);
        }
    }

    watchTable() {
        if (this.isInit) return false
        this.isInit = true


        this.table.addEventListener("scroll", (e) => {
            this.tableHeader.style.setProperty('--scrollWidth', `-${this.table.scrollLeft}px`);
        })
    }
}
